import * as React from 'react';
import { CnBox } from '@/components/cn-box';
import { observer } from '@formily/react';
export const CnFormGrid = observer((props) => {
    const { children, ...otherProps } = props;
    return React.createElement(CnBox, { ...otherProps }, children);
});
